import api from './api';

export interface CreateAnnouncementRequest {
  title: string;
  message: string;
  priority?: 'low' | 'medium' | 'high' | 'urgent';
  expires_at?: string | null;
  target_type: 'all' | 'role' | 'store' | 'cluster' | 'user';
  target_roles?: string[];
  target_stores?: string[];
  target_clusters?: string[];
  target_users?: string[];
}

export interface Announcement {
  id: string;
  title: string;
  description: string;
  type: string;
  priority: string;
  createdAt: string;
  createdBy?: string;
  createdByName?: string | null;
  createdByEmployeeId?: string | null;
  icon: string;
}

const announcementService = {
  /**
   * Get announcements for current user
   */
  getAnnouncements: async (): Promise<Announcement[]> => {
    const response = await api.get<{ success: boolean; message: string; data: Announcement[] }>('/dashboard/announcements');
    return response.data.data;
  },

  /**
   * Create a new announcement
   */
  createAnnouncement: async (announcementData: CreateAnnouncementRequest): Promise<{ created: number; notifications: any[] }> => {
    const response = await api.post<{ success: boolean; message: string; data: { created: number; notifications: any[] } }>(
      '/dashboard/announcements',
      announcementData
    );
    return response.data.data;
  },
};

export default announcementService;

